import { forwardRef } from "react";

import styles from "./styles.module.scss";

interface CameraViewProps {
  isBlurred?: boolean;
}

export const CameraView = forwardRef<HTMLVideoElement, CameraViewProps>(
  ({ isBlurred = false }, ref) => {
    return (
      <div className={styles.root}>
        <video
          ref={ref}
          playsInline
          muted
          className={`${styles.video} ${
            isBlurred ? styles.videoBlurred : styles.videoVisible
          }`}
        />
      </div>
    );
  },
);

CameraView.displayName = "CameraView";
